<template>
  <div class="alimentation-calculator-container">
    <div>
      <p class="paragraph">{{ description }}</p>
    </div>
    <div class="row">
      <div class="col-40"><img :src="imgAlimentation"  class="image-food"/></div>
      <div class="col-60">
        <div v-for="(alimentationType, index) in alimentationTypes" :key="index">
          <AlimentationInput :alimentationType="alimentationType" v-model="results[alimentationType.label]"
            @update:modelValue="$emit('update:modelValue', results);checkError()"></AlimentationInput>
        </div>
        <div class="row d-flex-end vertical-center mt-35px">
          <label class="label-total-input">Total</label><div class="position-relative"><div class="error">{{ error }}</div><input class="total-input w-100" type="number" :value="totalPercent" readonly/><div class="total-input-percent">%</div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AlimentationInput from '@/components/form/AlimentationInput'
export default {
  data() {
    return {
      results: {

      },
      error:null, 
      imgAlimentation: require('@/assets/images/alimentation2.png'),
      alimentationTypes: [
        { label:'Viande à chaque repas',
          factor:3300
        },
        { label:'Omnivore',
          factor:2500
        },
        { label:'Sans boeuf',
          factor:1900
        },
        { label:'Végétarien',
          factor:1700
        },
        { label:'Végétalien',
          factor:1500,
        }       
      ]
    }
  },
  components: {
    AlimentationInput,
  },
  props: {
    modelValue: Object,
    description: {
      type: String,
      default: 'Indiquez les proportions qui représentent le mieux le profil alimentaire des voyageurs. Par exemple, si toutes les personnes sont omnivores, vous pouvez inscrire 100% omnivore. Si un couple est composé d’une personne consommatrice de viande à chaque repas et d’une personne végétarienne, vous pouvez mettre 50% viande à tous les repas et 50% végétarien.'
    }
  },
  methods:{
    checkError(){
      if(this.totalPercent!==100){
        this.error='Le total de pourcentage doit être 100%'
        this.$emit('onError', true)
      }
      else{
        this.error=null
        this.$emit('onError', false)
      }
    }
  },
  computed:{
    totalPercent(){
      let total = 0
      Object.keys(this.results).forEach(element=>{
        if(this.results[element].percent){
          total+=parseFloat(this.results[element].percent)
        }
      })
      return total
    }
  },
  watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  }
}
</script>
<style scoped>
.alimentation-calculator-container {
  position: relative;
  background-color: white;
  padding: 40px;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}
.image-food{
  width:95%;
}
@media screen and (max-width: 750px) {
  .mobile-wrap{
    flex-wrap: wrap;
  }
  .col-40{
    width:100% !important;
  }
  .col-60{
    width:100% !important;
  }
}
@media screen and (max-width: 600px) {
  .col-40>img {
    width: 100%;
  }
}
</style>
